import React, { useEffect } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import { Header } from './components/sections/Header';
import { Footer } from './components/sections/Footer';
import { Home } from './pages/Home';
import { About } from './pages/About';
import { Privacy } from './pages/Privacy';
import { Terms } from './pages/Terms';
/**
 * Scrolls to the hash target after navigating between routes.
 * Lets header/footer links like "/#problem" land on the right section.
 */
function ScrollToHash() {
  const {
    pathname,
    hash
  } = useLocation();
  useEffect(() => {
    if (hash) {
      const el = document.querySelector(hash);
      if (el) {
        // wait a tick so the destination route has mounted
        window.setTimeout(() => el.scrollIntoView({
          behavior: 'smooth'
        }), 60);
        return;
      }
    }
    window.scrollTo({
      top: 0,
      left: 0
    });
  }, [pathname, hash]);
  return null;
}
export function App() {
  return <div className="flex min-h-full w-full flex-col bg-white font-body text-text" data-id="element-0" data-mp="3iiwasc8k4vxf">
      <ScrollToHash data-id="element-1" data-mp="3mkrbpfmkt7ao" />
      <Header data-id="element-2" data-mp="3mk84otygs3bf" />
      <main className="flex-1" data-id="element-3" data-mp="3mjq2zht18ww4">
        <Routes data-id="element-4" data-mp="3rc9hqi3ghy2i">
          <Route path="/" element={<Home data-id="element-6" data-mp="3rdkisa5iorpx" />} data-id="element-5" data-mp="3rbrc4uuwm7hx" />
          <Route path="/about" element={<About data-id="element-8" data-mp="5yi8qe3h5da" />} data-id="element-7" data-mp="3rd19fhtxnbni" />
          <Route path="/privacy" element={<Privacy data-id="element-10" data-mp="5gel8p3rovc" />} data-id="element-9" data-mp="6htjo98ovic" />
          <Route path="/terms" element={<Terms data-id="element-12" data-mp="2zld1r8m3ndb0" />} data-id="element-11" data-mp="82j0zgp5o9c" />
        </Routes>
      </main>
      <Footer data-id="element-13" data-mp="2zmo89g6xiz5t" />
    </div>;
}